import React, { Suspense } from 'react'
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom'

// routes config
import routes from '../routes'
import { makeStyles } from '@material-ui/core/styles';
import { Scrollbars } from 'react-custom-scrollbars';


const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    background: '#7d4599',
    //paddingBottom: '60px'
  },
  thisscroll: {
    height: '100vh'
    //maxHeight: 'calc(100vh - 140px) !important',
  },
}));

const TheContent = () => {
  const classes = useStyles();
  return (
    <Suspense fallback={loading}>
      <Switch>
        {routes.map((route, idx) => {
          return route.component && (
            <Route
              key={idx}
              path={route.path}
              exact={route.exact}
              name={route.name}
              //component={route.component}
              render={props => (
                <route.component {...props} isAuthed={true} />
              )}
            />
          )
        })}
        <Redirect from="/" to="/dashboard" />
      </Switch>
    </Suspense>
  )
}

export default React.memo(TheContent)
